import { GETREQUESTOPTIONS, instance } from '../apiService';

export type FacilityStage = 'onboarding' | 'trial' | 'active';

export interface FacilitySignal {
    key: string;
    label: string;
    current: number;
    target?: number;
    targetLabel?: string;
    displayFormat?: 'number' | 'percent' | 'currency';
    met?: boolean;
    weight?: number;
    breakdown?: Record<string, number>;
    trend?: number[];
}

export interface FacilityMetricsResult {
    stage: FacilityStage;
    signals: FacilitySignal[];
    score: number;
    completedCount: number;
    totalCount: number;
    period?: { start: string; end: string };
}

export interface FacilityMetricsParams {
    periodStart?: Date;
    periodEnd?: Date;
}

const buildRequestConfig = (params?: FacilityMetricsParams) => {
    const requestOptions = GETREQUESTOPTIONS();
    if (!params?.periodStart || !params?.periodEnd) {
        return requestOptions;
    }
    return {
        ...requestOptions,
        params: {
            periodStart: params.periodStart.toISOString(),
            periodEnd: params.periodEnd.toISOString(),
        },
    };
};

export const getMyFacilityMetrics = async (
    params?: FacilityMetricsParams
): Promise<FacilityMetricsResult> => {
    const res = await instance.get(
        '/api/facility-metrics/',
        buildRequestConfig(params)
    );
    return res.data;
};

export const getFacilityMetrics = async (
    departmentId: string,
    params?: FacilityMetricsParams
): Promise<FacilityMetricsResult> => {
    const res = await instance.get(
        `/api/facility-metrics/${departmentId}`,
        buildRequestConfig(params)
    );
    return res.data;
};
